// CSS Modules - component class name prefix: ProductTeaser__

<template>
  <div :class="$style.container">
    <div :class="$style.image">
      <a :href="resultLink">
        <span v-if="result.isNew" :class="$style.newProduct"></span>
        <img :src="result.image" :alt="result.alt" />
      </a>
    </div>
    <div :class="$style.content">
      <a :href="resultLink">
        <div>{{ result.type }}</div>
        <div :class="$style.title" v-html="result.title"></div>
        <div v-html="result.text"></div>
      </a>
    </div>
    <div :class="$style.properties">
      <div :class="$style.propertiesLeft"></div>
      <div :class="$style.propertiesRight">
        <a
          v-if="result.datasheetLink"
          :class="$style.data"
          :href="result.datasheetLink"
          target="_blank"
          @click="
            result.wtParams &&
              wtTrack(
                { cat: 'PRODUCTRESULTSHANDLER' },
                {
                  ...result.wtParams,
                  filename: result.datasheetLink
                }
              )
          "
        >
          <span>{{ config.productDatasheet }}</span>
        </a>
        <a :class="$style.button" :href="resultLink">
          <span>{{ config.productDetail }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductTeaser",
  props: {
    result: {
      type: Object,
      default: () => {}
    },
    config: {
      type: Object,
      default: () => {}
    },
    additionalUrlParam: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      wtTrack: window.wtTrack
    };
  },
  computed: {
    resultLink: function() {
      if (this.additionalUrlParam.length === 0) {
        return this.result.link;
      }

      return `${this.result.link}${
        this.result.link.indexOf("?") !== -1 ? "&" : "?"
      }${this.additionalUrlParam}`;
    }
  }
};
</script>

<style module lang="scss">
@import "./ProductTeaser.scss";
</style>
